export const SEARCH_RESULT_TYPE = {
    QUICK_NOTES: 'QUICK_NOTES',
    CURRENT_BOARD: 'CURRENT_BOARD',
};
